import React, { useContext } from 'react'
import { View } from 'oio-react'
import InitiativeMoreButton from 'src/sites/kits/Initiative/components/MoreButton'
import ObjectCoverImage from 'src/sites/kits/Object/components/CoverImage'
import ObjectJoinButton from 'src/sites/kits/Object/components/JoinButton'
import ObjectTypeLabel from 'src/sites/kits/Object/components/TypeLabel'
import { Subtitle, Title } from 'src/sites/kits/UI'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'

const ObjectViewHeader = () => {
   const { theme } = useGlobalState()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const isGroupOrResource = ['group', 'resource'].includes(initiative.class)

   return (
      <View
         display="flex"
         width="100%"
         flexFlow="column[a] row[b-f]">
         {isGroupOrResource && (
            <View
               flex="0 0 auto"
               marginRight="30px"
               marginTop="10px"
               marginBottom="20px[a-b] 40px"
               width={initiative.subtitle
                  ? '90px[a-b] 120px[c-d] 175px[e-f]'
                  : '90px[a-b] 120px[c-d] 135px[e-f]'
               }>
               <ObjectCoverImage aspectRatio={1} defaultThumbnailIconSize="50px" />
            </View>
         )}
         <View width="100%">
            <View marginBottom="5px">
               <ObjectTypeLabel />
            </View>
            <View marginBottom={initiative.subtitle ? '10px' : '30px'}>
               <Title size="xl" color={theme.tmpContentTitleColor}>
                  {initiative.name}
               </Title>
            </View>
            {initiative.subtitle && (
               <View marginBottom="30px">
                  <Subtitle>
                     {initiative.subtitle}
                  </Subtitle>
               </View>
            )}
            {isGroupOrResource && (
               <View display="flex" alignItems="center" width="100%[a]">
                  <View flex="1 1 auto[a] 0 0 auto[b-f]">
                     {initiative.class !== 'discussion' && (
                        <ObjectJoinButton
                           buttonRounded
                           buttonSize="lg"
                           buttonWidth="100%[a]"
                           popoverAnchorOriginVertical="bottom"
                        />
                     )}
                  </View>
                  {initiative.currentUserCanEdit && (
                     <View flex="0 0 auto" marginLeft="3px">
                        <InitiativeMoreButton
                           buttonSize="lg"
                           buttonWidth="30px"
                           popoverAnchorOriginVertical="top"
                        />
                     </View>
                  )}
               </View>
            )}
         </View>
      </View>
   )
}

export default ObjectViewHeader
